/* ============================================================
   cs-imgbox
   記事内の画像リンク（EC-CUBE 由来の .boxer / .galleryBox 内）を
   ふわっとフェードインするオーバーレイで開く。
   ライブラリ依存なし。
   ※ 商品ギャラリーのライトボックス（custom-size-atc.js）と
      クラス名が衝突していたため cs-lightbox → cs-imgbox に改名。
   ============================================================ */
(function () {
  'use strict';

  // 画像ファイルを指しているリンクだけを対象にする
  var IMAGE_RE = /\.(png|jpe?g|gif|webp|avif)(\?|#|$)/i;
  // 対象となるリンクの範囲。class が付いていないリンクも拾えるようにしている
  var LINK_SELECTOR = 'a.boxer, .galleryBox a, .listBox a';

  var overlay = null;
  var image = null;
  var lastFocused = null;

  function isImageLink(a) {
    if (!a) return false;
    var href = a.getAttribute('href') || '';
    return IMAGE_RE.test(href);
  }

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'cs-imgbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', '画像の拡大表示');
    overlay.innerHTML =
      '<button type="button" class="cs-imgbox__close" aria-label="閉じる">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path d="M5 5 L19 19" /><path d="M19 5 L5 19" />' +
        '</svg>' +
      '</button>' +
      '<div class="cs-imgbox__stage"><img class="cs-imgbox__image" alt=""></div>';

    document.body.appendChild(overlay);
    image = overlay.querySelector('.cs-imgbox__image');

    // 閉じるボタン、または画像の外側をクリックで閉じる
    overlay.addEventListener('click', function (e) {
      if (e.target.closest('.cs-imgbox__close')) { close(); return; }
      if (!e.target.closest('.cs-imgbox__image')) close();
    });
  }

  function markLoaded() {
    image.classList.add('is-loaded');
  }

  function open(href, alt) {
    if (!overlay) build();

    lastFocused = document.activeElement;

    image.classList.remove('is-loaded');
    image.alt = alt || '';
    image.onload = markLoaded;
    image.src = href;
    if (image.complete && image.naturalWidth > 0) {
      requestAnimationFrame(markLoaded);
    }

    // スクロールバーの幅ぶんの横ズレを防ぐ
    var gap = window.innerWidth - document.documentElement.clientWidth;
    if (gap > 0) document.body.style.paddingRight = gap + 'px';
    document.documentElement.classList.add('cs-imgbox-open');

    // 次のフレームで付与してトランジションを確実に走らせる
    requestAnimationFrame(function () {
      overlay.classList.add('is-visible');
      overlay.querySelector('.cs-imgbox__close').focus({ preventScroll: true });
    });
  }

  function close() {
    if (!overlay || !overlay.classList.contains('is-visible')) return;

    overlay.classList.remove('is-visible');
    image.classList.remove('is-loaded');
    document.documentElement.classList.remove('cs-imgbox-open');
    document.body.style.paddingRight = '';

    if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
    lastFocused = null;

    // フェードアウト後に src を空にしてメモリを解放
    window.setTimeout(function () {
      if (overlay && !overlay.classList.contains('is-visible')) image.removeAttribute('src');
    }, 400);
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest(LINK_SELECTOR);
    if (!link || !isImageLink(link)) return;
    if (link.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey) return;

    e.preventDefault();

    var inner = link.querySelector('img');
    open(link.getAttribute('href'), inner ? inner.getAttribute('alt') : '');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') close();
  });
})();